/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface User {
  userID: number;
  agentId: string;
  email: string;
  name: string;
  permissions: string[];
  roles: string[];
}

export interface AuthState {
  isAuthenticated: boolean;
  user: User | null;
  isLoading: boolean;
  systemSelectorZoomUrl: string | null;
}

export const defaultAuthState: AuthState = {
  isAuthenticated: false,
  user: null,
  isLoading: true,
  systemSelectorZoomUrl: null
};

export const authSlice = createSlice({
  name: 'auth',
  initialState: defaultAuthState,
  reducers: {
    setIsAuthenticated: (state, action: PayloadAction<boolean>) => {
      state.isAuthenticated = action.payload;
    },
    setUser: (state, action: PayloadAction<User | null>) => {
      state.user = action.payload;
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setSystemSelectorZoomUrl: (state, action: PayloadAction<string | null>) => {
      state.systemSelectorZoomUrl = action.payload;
    }
  }
});

export const {
  setIsAuthenticated,
  setUser,
  setIsLoading,
  setSystemSelectorZoomUrl
} = authSlice.actions;

export default authSlice.reducer;
